import { useApiClient } from '../../hooks/useApiClient';
import { ApiResponse } from '../../types/ApiResponse.type';
import { Changelog } from '../../types/Changelog/Changelog.type';
import { ChangelogCreate } from '../../types/Changelog/ChangelogCreate.type';
import { GetChangelogsQueryParams } from '../../types/QueryParams.type';
import { buildQueryString } from '../../utils/buildQueryString';

export const useChangelogApi = () => {
  const apiClient = useApiClient();

  return {
    getChangelogs: (params: GetChangelogsQueryParams): Promise<ApiResponse<Changelog[]>> => {
      const queryString = buildQueryString(params);

      return apiClient(`/changelogs/${queryString}`);
    },

    getChangelogById: (id: number): Promise<Changelog> => {
      return apiClient(`/changelogs/${id}`);
    },

    updateChangelog: (id: number, changelogData: ChangelogCreate): Promise<Changelog> => {
      return apiClient(`/changelogs/${id}`, {
        method: 'PUT',
        body: JSON.stringify(changelogData),
      });
    },

    createChangelog: (changelogData: ChangelogCreate): Promise<Changelog> => {
      return apiClient('/changelogs/', {
        method: 'POST',
        body: JSON.stringify(changelogData),
      });
    },

    deleteChangelog: (id: number): Promise<void> => {
      return apiClient(`/changelogs/${id}`, {
        method: 'DELETE',
      });
    },
  };
};
